import { getAPI } from "../../api/apis";
import { REACT_APP_CANDIDATE } from "../../utils/common";

export async function getDetails(Id: string | null) {
  const Details = getAPI(REACT_APP_CANDIDATE + `/candidates/${Id}`);
  return Details;
}
